import { Component, NgZone } from '@angular/core';

import { NavController, ModalController, NavParams, Events} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';

import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { AlertController } from 'ionic-angular';
import { ParplatzData } from '../../providers/pp-data';
import { BlockingtimeData } from '../../providers/blockingtime-data';
import moment from 'moment';
@Component({
  selector: 'blockingtime-create',
  templateUrl: 'blockingtime-create.html'
})
export class BlockingtimeCreatePage {
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  oSelectedBlockingtime;
  maxDate;
  minDate;
  btids;
  oBlockingtime;
  constructor(
              private navParams: NavParams
            , public events: Events
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , private alertCtrl: AlertController
            , public parplatzData : ParplatzData
            , public blockingtimeData : BlockingtimeData
            ) {
    //let selectedpp = navParams.get('pp');
    this.minDate = moment.utc().startOf('day').format('YYYY-MM-DD');
    this.maxDate = moment.utc().add(2, 'y').format('YYYY-MM-DD');
    this.oBlockingtime = {};

    let d = moment();
    d.add(1, "day");
    d.set({hour:10,minute:0,second:0,millisecond:0})
    this.oBlockingtime.dBegin = d.toISOString();
    d.add(2, "hour");
    this.oBlockingtime.dEnd = d.toISOString();
    this.oBlockingtime.strDescription = "";
    this.oBlockingtime.bSelected = false;
    this.oBlockingtime.bInformationonly = false;

    Promise.all([
      this.parplatzData.load(),            
    ]).then(data => {
      this.oBlockingtime.aPP = new Array();
      for(let i=0; i<data[0].length; i++){
        this.oBlockingtime.aPP.push({grundind: data[0][i]["grundid"], name:data[0][i]["name"], kurzname:data[0][i]["kurzname"], bSelected:false});
      }
      this.events.publish('btmodel:loaded');
      //this.aPP = data[0];
    });   

    this.btids = "";
    this.init();
    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oSelectedBlockingtime = navParams.data;
    
    this.btids = "";
    this.events.subscribe('btmodel:loaded', () => {
      
      if(this.oSelectedBlockingtime && this.oSelectedBlockingtime.begin){      
        this.loadRecord(this.oSelectedBlockingtime);
        this.btids = this.oSelectedBlockingtime.btids;
      }
      else{
        this.btids = "";
      }
    });    
  
   }

   public loadRecord(bt){
    this.oBlockingtime.dBegin = bt.begin;
    this.oBlockingtime.dEnd = bt.end;
    this.oBlockingtime.strDescription = bt.description;

    this.oBlockingtime.bInformationonly = bt.informationonly == "1";
    if(this.oBlockingtime.aPP){      
      for(let pp of this.oBlockingtime.aPP){
        //Check if PP is selected
        for(let assignedpp of bt.pp){
          if(assignedpp.grundstueck_id == pp.grundind){
            pp.bSelected = true;
            //pp.btid = assignedpp.id;
            break;
          }
        }
        
     }
    }
    
  }
   init(){


   }
  doBeginUpdate(event){
    console.log(event);

  }
  onCreateBlockingtime(){
    if(!this.oBlockingtime.strDescription){
      let alert = this.alertCtrl.create();
      alert.setTitle("Grund/Info angeben");
      alert.setSubTitle('Bitte geben Sie einen Grund/Info für die Sperre/Ausnahmeinfo an');
      alert.addButton('Ok');
      alert.present();
      return;
    }
    let aSelectedPP = Array();
    for(let i=0; i<this.oBlockingtime.aPP.length; i++){
      if(this.oBlockingtime.aPP[i].bSelected){
        aSelectedPP.push(this.oBlockingtime.aPP[i]);
      }
    }
    if(aSelectedPP.length<=0){
      let alert = this.alertCtrl.create();
      alert.setTitle("Parkplätze auswählen");
      alert.setSubTitle('Bitte geben betroffene Parkplätze auswählen');
      alert.addButton('Ok');
      alert.present();
      return;
    }    
    var data = JSON.stringify({
          pp: aSelectedPP,
          description: this.oBlockingtime.strDescription,
          begin: this.oBlockingtime.dBegin,
          end: this.oBlockingtime.dEnd,
          informationonly: this.oBlockingtime.bInformationonly,
          btids: this.btids,
          token: this.userData.jwt
      });
      if(this.btids == ""){
        Promise.all([
          this.blockingtimeData.create(data),            
        ]).then(data => {
          //console.log(data);
          //this.einsatzplan = this.einsatzplanData.data;      
          this.navCtrl.pop();
        });   
  
      }
      else{
        Promise.all([
          this.blockingtimeData.update(data),            
        ]).then(data => {
          console.log(data);
          //this.einsatzplan = this.einsatzplanData.data;      
          this.navCtrl.pop();
        });   

      }


  }

  confirmDelete(){
    let title = "";
    let param: any;
     
     title = "Soll die Sperrzeit '"+this.oBlockingtime.strDescription+"' gelöscht werden?";
     //param = {pp : bt.pp};

     let alert = this.alertCtrl.create();
     alert.setTitle(title);
     alert.addButton({
       text: 'Ja, löschen',
       handler: (data: any) => {
           
           Promise.all([
               this.blockingtimeData.delete(this.btids),            
             ]).then(data => {
                this.navCtrl.pop();
             });            
           //this.testCheckboxOpen = false;
       }
     });
     alert.addButton('Nein');

     alert.present();
     
  
 }
  
}



// WEBPACK FOOTER //
// ./src/pages/blockingtime/blockingtime-create.ts